import store from '../store/index'

export default (async (to, from, next) => {
    if (store.getters["IN_PROGRESS"])
        await store.getters["IN_PROGRESS"]
    next();
});
